import { IClassificacao } from "app/types/IClassificacao";
import { Permissao } from "app/types/Permissao";
import { obterPermissao } from "app/use-cases/obterPermissao";
import React, { useEffect, useState } from "react";
import { AbaClassificacao } from "./AbaClassificacao";

export type AbaClassificacaoContainerProps = {

  classificacoesDisponiveis: IClassificacao[]
  onSalvarClassificacoesSelecionadas: (selecionados: IClassificacao[]) => void;
  onSalvarClassificacoesDisponiveis: (disponiveis: IClassificacao[]) => void;
  classificacoesSelecionadas: IClassificacao[]
  somenteLeitura: boolean
}


export const AbaClassificacaoContainer = (props: AbaClassificacaoContainerProps) => {
  const [classificacoesSelecionadas, setClassificacoesSelecionadas] = useState<IClassificacao[]>(props.classificacoesSelecionadas);
  const [classificacoesDisponiveis, setClassificacoesDisponiveis] = useState<IClassificacao[]>(props.classificacoesDisponiveis);
  const [permissoes, setPermissoes] = useState<Permissao[]>([])

  const atualizarPermissoes = async () => {
    setPermissoes([
      {
        Acao: "ALTERAR_CLASSIFICACAO",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ALTERAR_CLASSIFICACAO" })
      }
    ])
  }

  const valorPermissaoPorAcao = (nome: string) => permissoes.find(p => p.Acao == nome)?.Permitido

  const onIncluirClassificacoesSelecionadas = (classificacao: IClassificacao) => {
    setClassificacoesSelecionadas(classificacoesSelecionadas.concat(classificacao));
    const index = classificacoesDisponiveis.indexOf(classificacao);
    index > -1 && classificacoesDisponiveis.splice(index, 1);
    setClassificacoesDisponiveis([...classificacoesDisponiveis]);
  };

  const onRemoverClassificacoesSelecionadas = (classificacao: IClassificacao) => {
    setClassificacoesDisponiveis(classificacoesDisponiveis.concat(classificacao));
    const index = classificacoesSelecionadas.indexOf(classificacao);
    index > -1 && classificacoesSelecionadas.splice(index, 1);
    setClassificacoesSelecionadas([...classificacoesSelecionadas]);
  };

  useEffect(() => {
    props.onSalvarClassificacoesSelecionadas(classificacoesSelecionadas.map((classificacoes) => classificacoes));
    props.onSalvarClassificacoesDisponiveis(classificacoesDisponiveis.map((classificacoes) => classificacoes));
  }, [classificacoesSelecionadas, classificacoesDisponiveis]);

  useEffect(() => {
    atualizarPermissoes()
  }, []);

  return (
    <div className="_mt-8">
      <AbaClassificacao
        somenteLeitura={props.somenteLeitura}
        temPermissaoAlterar={!props.somenteLeitura && valorPermissaoPorAcao("ALTERAR_CLASSIFICACAO")}
        classificacoesDisponiveis={classificacoesDisponiveis}
        classificacoesSelecionadas={classificacoesSelecionadas}
        onIncluirClassificacoesSelecionadas={onIncluirClassificacoesSelecionadas}
        onRemoverClassificacoesSelecionadas={onRemoverClassificacoesSelecionadas}
      />
    </div>
  );
};
